import { mergeUnique } from '../../helpers/array/array';
import {
  FETCH_TRACKING_LINKS_START,
  FETCH_TRACKING_LINKS_SUCCESS,
  FETCH_TRACKING_LINKS_FAILED,
  CREATE_TRACKING_LINK_START,
  CREATE_TRACKING_LINK_SUCCESS,
  CREATE_TRACKING_LINK_FAILED,
  UPDATE_TRACKING_LINK_START,
  UPDATE_TRACKING_LINK_SUCCESS,
  UPDATE_TRACKING_LINK_FAILED,
  DELETE_TRACKING_LINK_START,
  DELETE_TRACKING_LINK_SUCCESS,
  DELETE_TRACKING_LINK_FAILED
} from "../actions/ActionConstant";

export const initialState = {
  trackingLinks: {
    data: [],
    loading: true,
    error: false,
    hasNext: false,
    page: 1,
    metadata: {}
  },
  createTrackingLink: {
    loading: false,
    error: false,
  },
  updateTrackingLink: {
    loading: false,
    error: false,
  },
  deleteTrackingLink: {
    loading: false,
    error: false,
  },
};

const trackingLinkReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TRACKING_LINKS_START:
      return {
        ...state,
        trackingLinks: {
          ...state.trackingLinks,
          data: action.payload?.page === 1 ? [] : state.trackingLinks.data,
          loading: true,
          error: false,
        },
      };

    case FETCH_TRACKING_LINKS_SUCCESS: {
      const newPage = action.payload?.metadata?.pagination?.page || 1;
      const currentData = state.trackingLinks.data || [];
      const fetchedData = action.payload.data || [];
      const numberOfPages = action.payload?.metadata?.pagination?.numberOfPages || 1;

      const mergedData = newPage === 1
        ? fetchedData
        : mergeUnique(currentData, fetchedData, 'id');

      return {
        ...state,
        trackingLinks: {
          ...state.trackingLinks,
          data: mergedData,
          metadata: action.payload?.metadata?.pagination || {},
          loading: false,
          error: false,
          hasNext: newPage < numberOfPages,
          page: newPage,
        },
      };
    }

    case FETCH_TRACKING_LINKS_FAILED:
      return {
        ...state,
        trackingLinks: {
          ...state.trackingLinks,
          loading: false,
          error: true,
        },
      };

    case CREATE_TRACKING_LINK_START:
      return {
        ...state,
        createTrackingLink: {
          loading: true,
          error: false,
        },
      };

    case CREATE_TRACKING_LINK_SUCCESS:
      return {
        ...state,
        createTrackingLink: {
          loading: false,
          error: false,
        },
      };

    case CREATE_TRACKING_LINK_FAILED:
      return {
        ...state,
        createTrackingLink: {
          loading: false,
          error: true,
        },
      };

    case UPDATE_TRACKING_LINK_START:
      return {
        ...state,
        updateTrackingLink: {
          loading: true,
          error: false,
        },
      };

    case UPDATE_TRACKING_LINK_SUCCESS:
      return {
        ...state,
        updateTrackingLink: {
          loading: false,
          error: false,
        },
        trackingLinks: {
          ...state.trackingLinks,
          data: state.trackingLinks.data.map(item =>
            item.id === action.payload.id ? { ...item, ...action.payload } : item
          ),
        },
      };

    case UPDATE_TRACKING_LINK_FAILED:
      return {
        ...state,
        updateTrackingLink: {
          loading: false,
          error: true,
        },
      };

    case DELETE_TRACKING_LINK_START:
      return {
        ...state,
        deleteTrackingLink: {
          loading: true,
          error: false,
        },
      };

    case DELETE_TRACKING_LINK_SUCCESS:
      return {
        ...state,
        deleteTrackingLink: {
          loading: false,
          error: false,
        },
        trackingLinks: {
          ...state.trackingLinks,
          data: [],
        },
      };

    case DELETE_TRACKING_LINK_FAILED:
      return {
        ...state,
        deleteTrackingLink: {
          loading: false,
          error: true,
        },
      };

    default:
      return state;
  }
};

export default trackingLinkReducer;

